import { render } from "./LanguageComponent.vue?vue&type=template&id=9a0ab0a0&scoped=true"
import script from "./LanguageComponent.vue?vue&type=script&lang=js"
export * from "./LanguageComponent.vue?vue&type=script&lang=js"

import "./LanguageComponent.vue?vue&type=style&index=0&id=9a0ab0a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a0ab0a0"]])

export default __exports__